<template>
  <main class="pt-0">
    <div class="tab-header">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a href='#tab-0' class="nav-link active show" role="tab" data-toggle="tab">基本資料</a>
        </li>
        <li v-if="$store.state.custInfo.ID !== '' && !loadingCust" class="nav-item">
          <a href='#tab-1' @click="policyData()" role="tab" data-toggle="tab" class="nav-link">保單資訊</a>
        </li>
        <!-- <li class="nav-item">
          <a href='#tab-2' role="tab" data-toggle="tab"  class="nav-link">紀錄簿</a>
        </li>
        <li class="nav-item">
          <a href='#tab-3' role="tab" data-toggle="tab"  class="nav-link">申辦進度</a>
        </li> -->
      </ul>
    </div>
    <div class="tab-content">
      <div id="tab-0" class="tab-pane active show" role="tabpanel" 
      :class="{'section-loading': loadingCust}">
        <div class="user card">
          <div class="row">
            <div class="col-5 pl-4">
              <h3 v-if="customer.name.length < 6" class="mt-3">{{customer.name}}</h3>
              <div v-else>
                <h3 class="mt-3">{{customer.name && customer.name.slice(0,5)}}...</h3>
                <span class="link text-underline"
                @hover="currentName = customer"
                @click="currentName = customer"
                v-popover:namepop.right>
                  看全名
                </span>
              </div>
              <div class="meta">
                <span class="mr-2">{{customer.birthday | ageCounter | emptyField}}歲</span>
                <level :lv="Number(customer.vip_lvl)" />
              </div>
            </div>
            <div class="col-7">
              <div class="item row">
                <div class="col-5"><b>性別</b></div>
                <div class="col-7">{{customer.id | sexFormat}}</div>
              </div>
              <div class="item row">
                <div class="col-5"><b>ID</b></div>
                <div class="col-7">{{customer.id | emptyField}}</div>
              </div>
              <div class="item row">
                <div class="col-5"><b>生日</b></div>
                <div class="col-7">{{customer.birthday | dateFormat}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mt-4">
          <div class="user-item">
            <div class="label">LINE ID</div>
            <div class="content">{{customer.lineid | emptyField}}</div>
            <div class="action">
              <a class="icon-img">
                <img :src="`${BaseUrl}assets/common/icon-line.png`" width="24"
                :srcset="`${BaseUrl}assets/common/icon-line@2x.png`">
              </a>
            </div>
          </div>
          <div class="user-item">
            <div class="label">手機</div>
            <div class="content">{{customer.mobile | emptyField}}</div>
            <div class="action">
              <a class="btn btn-sm btn-icon btn-default m-0" :href="`tel:${customer.mobile}`"><i class="icon-mobile"></i></a>
            </div>
          </div>
          <div class="user-item">
            <div class="label">住家電話</div>
            <div class="content">{{customer.tel | homeTelFormat}}</div>
            <div class="action">
              <a class="btn btn-sm btn-icon btn-default m-0" :href="`tel:${customer.tel}`"><i class="icon-telephone"></i></a>
            </div>
          </div>
          <div class="user-item">
            <div class="label">公司電話</div>
            <div class="content">{{customer.corpTel | corpTelFormat}}</div>
            <div class="action">
              <a class="btn btn-sm btn-icon btn-default m-0" :href="`tel:${customer.corpTel}`"><i class="icon-telephone"></i></a>
            </div>
          </div>
          <div class="user-item">
            <div class="label">傳真</div>
            <div class="content">{{customer.fax | emptyField}}</div>
            <div class="action">
            </div>
          </div>
          <div class="user-item">
            <div class="label">現居地址</div>
            <div class="content">
              <span v-if="customer.homeAdd && !customer.homeAdd[1] && !customer.homeAdd[2] && !customer.homeAdd[3]">— —</span>
                <a v-else class="link text-underline"
                target="_blank"
                :href="`https://www.google.com/maps/place/${customer.homeAdd}`"
                >
                {{customer.homeAdd | addressFormat }}
                </a>
            </div>
            <div class="action">
              <a class="btn btn-sm btn-icon btn-default m-0"><i class="icon-maps"></i></a>
            </div>
          </div>
          <div class="user-item">
            <div class="label">公司地址</div>
            <div class="content">
              <span v-if="customer.corpAdd && !customer.corpAdd[1] && !customer.corpAdd[2] && !customer.corpAdd[3]">— —</span>
                <a v-else class="link text-underline"
                target="_blank"
                :href="`https://www.google.com/maps/place/${customer.corpAdd}`"
                >
                {{customer.corpAdd  | addressFormat }}
                </a>
            </div>
            <div class="action">
              <a class="btn btn-sm btn-icon btn-default m-0"><i class="icon-maps"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div id="tab-1" class="tab-pane" role="tabpanel">
        <h6 class="mt-0 bg-white full-layout">
          <img
          :src="customer.gender === 0 ?
          `${BaseUrl}assets/common/gender_woman_s.png` :
          (customer.gender === 1 ?
          `${BaseUrl}assets/common/gender_man_s.png` :
          `${BaseUrl}assets/common/gender_unknow_s.png`)"
          :srcset="customer.gender === 0 ?
          `${BaseUrl}assets/common/gender_woman_s@2x.png` :
          (customer.gender === 1 ?
          `${BaseUrl}assets/common/gender_man_s@2x.png` :
          `${BaseUrl}assets/common/gender_unknow_s@2x.png`)"
          width="20" />
          <span class="text">
            {{customer.name}} 的保單
          </span>
        </h6>
        <div v-if="loadingIns" class="load-mag text-center">
          <div class="section-loading d-inline-block" style="height:20px; width:30px"></div> 資料讀取中 . . .
        </div>
        <div v-else class="collapse-panel">
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='cathay'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='cathay'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰人壽保單
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='cathay'}">
              <div class="card insurance"
              v-for="(ins, i) in insurance.cathay"
              :key="`cathay-insurance-${i}`">
                <div @click="toInsDetail('cathay', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.prod_nm}}</h5>
                    <small># {{ins.policy_no}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item mr-4">
                      <span class="tag-box mr-1">要</span>
                      <span @click="resetCustId(ins.apc_id)" class="link text-underline">
                        {{ins.apc_name}}
                      </span>
                    </span>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.insd_id)" class="link text-underline">
                        {{ins.insd_name}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel blue">
            <div class="panel-header" @click="curentCollapse='others'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='others'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                其他人壽保單
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='others'}">
              <div class="card insurance"
              v-for="(ins, i) in insurance.others"
              :key="`others-insurance-${i}`">
                <div @click="toInsDetail('others', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.product}}</h5>
                    <small># {{ins.policynumber}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item mr-4">
                      <span class="tag-box mr-1">要</span>
                      <span>
                        {{ins.applicant}}
                      </span>
                    </span>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.personalid)" class="link text-underline">
                        {{ins.fullname}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='group'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='group'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰人壽團險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='group'}">
              <div class="card insurance"
              v-for="(ins, i) in insurance.group"
              :key="`group-insurance-${i}`">
                <div @click="toInsDetail('group', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.cepln_nm}}</h5>
                    <small># {{ins.POLICY_NO}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item mr-4">
                      <span class="tag-box mr-1">要</span>
                      <span @click="resetCustId(ins.APC_ID)" class="link text-underline">
                        {{ins.APC_NAME}}
                      </span>
                    </span>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.INSD_ID)" class="link text-underline">
                        {{ins.INSD_NAME}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='accident'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='accident'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                <!-- 國壽要求意外險改成旅平險 -->
                國泰人壽-旅平險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='accident'}"><div class="card insurance"
              v-for="(ins, i) in insurance.accident"
              :key="`accident-insurance-${i}`">
                <div @click="toInsDetail('accident', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.POLICY_TYPE_NM}}</h5>
                    <small># {{ins.POLICY_NO}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item mr-4">
                      <span class="tag-box mr-1">要</span>
                      <span v-if="ins.APC_NAME" @click="resetCustId(ins.APC_ID)" class="link text-underline">
                        {{ins.APC_NAME}}
                      </span>
                      <span v-else class="text">
                        — —
                      </span>
                    </span>
                    <!-- 國壽要求被保人拿掉 -->
                    <!-- <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span v-if="ins.INSD_NAME" @click="resetCustId(ins.INSD_ID)" class="link text-underline">
                        {{ins.INSD_NAME}}
                      </span>
                      <span v-else class="text">
                        — —
                      </span>
                    </span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>                    
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='health'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='health'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰產險-健康險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='health'}"><div class="card insurance"
              v-for="(ins, i) in insurance.health"
              :key="`health-insurance-${i}`">
                <div @click="toInsDetail('health', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.CEPLN_NM}}</h5>
                    <small># {{ins.CEPLCNO}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.CEISDNO)" class="link text-underline">
                        {{ins.CEISDNM}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='harm'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='harm'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰產險-傷害險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='harm'}"><div class="card insurance"
              v-for="(ins, i) in insurance.harm"
              :key="`harm-insurance-${i}`">
                <div @click="toInsDetail('harm', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.CEPLN_NM}}</h5>
                    <small># {{ins.CEPLCNO}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item mr-4">
                      <span class="tag-box mr-1">要</span>
                      <span @click="resetCustId(ins.CEAPCNO)" class="link text-underline">
                        {{ins.CEAPCNM}}
                      </span>
                    </span>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.CEISDNO)" class="link text-underline">
                        {{ins.CEISDNM}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='cathayNewInsure'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='cathayNewInsure'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰產險-新種險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='cathayNewInsure'}"><div class="card insurance"
              v-for="(ins, i) in insurance.cathayNewInsure"
              :key="`cathay-new-insurance-${i}`">
                <div @click="toInsDetail('cathayNewInsure', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.CEPLN_NM}}</h5>
                    <small># {{ins.CEPLCNO}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.CEISDNO)" class="link text-underline">
                        {{ins.CEISDNM}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel blue">
            <div class="panel-header" @click="curentCollapse='otherNewInsure'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='otherNewInsure'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                其他產險-新種險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='otherNewInsure'}"><div class="card insurance"
              v-for="(ins, i) in insurance.otherNewInsure"
              :key="`other-new-insurance-${i}`">
                <div @click="toInsDetail('otherNewInsure', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.ContractType}}</h5>
                    <small># {{ins.PolicyNumber}}  
                      <span class="action">|</span>
                        {{ins.CompanyName}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span>
                        {{ins.FullName}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='travel'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='travel'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰產險-旅綜險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='travel'}"><div class="card insurance"
              v-for="(ins, i) in insurance.travel"
              :key="`travel-insurance-${i}`">
                <div @click="toInsDetail('travel', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.CEPLN_NM}}</h5>
                    <small># {{ins.CEPLCNO}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.CEISDNO)" class="link text-underline">
                        {{ins.CEISDNM}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>          
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='cathayCar'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='cathayCar'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰產險-車險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='cathayCar'}"><div class="card insurance"
              v-for="(ins, i) in insurance.cathayCar"
              :key="`cathay-car-insurance-${i}`">
                <div @click="toInsDetail('cathayCar', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.cepln_nm}}</h5>
                    <small># {{ins.ceplcno}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.ceisdno)" class="link text-underline">
                        {{ins.ceisdnm}}
                      </span>
                    </span>
                  </div>
                  <div>車牌號碼
                    <span >{{ins.lic_no}}</span>
                  </div>                  
                </div>
              </div>
            </div>
          </div>
          <div class="panel green">
            <div class="panel-header" @click="curentCollapse='cathayFire'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='cathayFire'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                國泰產險-火險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='cathayFire'}"><div class="card insurance"
              v-for="(ins, i) in insurance.cathayFire"
              :key="`cathay-fire-insurance-${i}`">
                <div @click="toInsDetail('cathayFire', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.cepln_nm}}</h5>
                    <small># {{ins.ceplcno}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span @click="resetCustId(ins.ceisdno)" class="link text-underline">
                        {{ins.ceisdnm}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel blue">
            <div class="panel-header" @click="curentCollapse='otherCar'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='otherCar'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                其他產險-車險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='otherCar'}"><div class="card insurance"
              v-for="(ins, i) in insurance.otherCar"
              :key="`oather-car-insurance-${i}`">
                <div @click="toInsDetail('otherCar', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.ContractType}}</h5>
                    <small># {{ins.PolicyNumber}}  
                      <span class="action">|</span>
                        {{ins.CompanyName}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span>
                        {{ins.FullName}}
                      </span>
                    </span>
                  </div>
                  <div>車牌號碼
                    <span >{{ins.LicensePlate}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel blue">
            <div class="panel-header" @click="curentCollapse='otherFire'">
              <h5 class="panel-title">
                <div class="float-right">
                  <i class="icon-collapse_up" v-if="curentCollapse==='otherFire'"></i>
                  <i class="icon-collapse_down" v-else></i>
                </div>
                其他產險-火險
              </h5>
            </div>
            <div class="panel-body"
            :class="{'active': curentCollapse==='otherFire'}"><div class="card insurance"
              v-for="(ins, i) in insurance.otherFire"
              :key="`oather-fire-insurance-${i}`">
                <div @click="toInsDetail('otherFire', ins)" class="segment insurance-info">
                  <div class="content">
                    <h5>{{ins.ContractType}}</h5>
                    <small># {{ins.PolicyNumber}}  
                      <span class="action">|</span>
                        {{ins.CompanyName}}</small>
                  </div>
                  <div class="action">
                    ❯
                  </div>
                </div>
                <div class="segment insurance-data">
                  <div>
                    <span class="item">
                      <span class="tag-box mr-1">被</span>
                      <span>
                        {{ins.FullName}}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tab-2" class="tab-pane" role="tabpanel"></div>
      <div id="tab-3" class="tab-pane" role="tabpanel"></div>
    </div>

    <popover name="namepop" :width="200">
      <div v-if="currentName">
        <p style="word-break: break-all;">{{currentName.name}}</p>
      </div>
    </popover>
  </main>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Level from '../../components/Level'
import { getCustInfo } from '@/service'
import { getCustInsurance } from '@/service'
import { getCustOtherInsurance } from '@/service'
import { getCustInsuranceGroup } from "../../service";
import { getCustInsuranceAccident } from "../../service";
import { getCustInsurance_CCIPLN4 } from "../../service";
import { getCustInsurance_CCIPLN2 } from "../../service";
import { getCustInsurance_CCIPLN1 } from "../../service";
import { getCustInsurance_CCIPLN3 } from "../../service";
import { getCustInsurance_CCIPLC1 } from "../../service";
import { getCustInsurance_CCIPLF1 } from "../../service";
import { queryPaymentMessage } from "../../service";
import { getAllInsurances } from "../../service";

export default {
  name: 'Index',
  components: { Level },
  watch: {
    loadingIns (val) {
      if (!val) {
        this.registerHanlink()
      }
    }
  },
  computed: {
    ...mapGetters(['BaseUrl']),
    loadingIns () {  // 判斷保單是否讀取完成
      let bool = false
      for (let idx in this.insLoading) {
        if(this.insLoading[idx]) {
          bool = true
        }
      }
      return bool
    }
  },
  data () {
    return {
      currentName: null,
      insLoading: {
        cathay: false, //國泰
        others: false, //其他
        group: false, //國泰團險
        accident: false, //國泰意外
        health: false, //國泰健康
        harm: false, //國泰傷害
        cathayNewInsure: false, //國泰新種
        travel: false, //國泰綜旅
        cathayCar: false, //國泰車險
        cathayFire: false, //國泰火險
        otherRest: false //同業其他險        
      },
      keyowrd: '',
      curentCollapse: 'cathay',
      currentTab: 0,
      loadingCust: false,
      customer:{
        name: '',
        id: '',
        gender: 0,
        lv: 0,
        birthday: '',
        identityID: '',
        lineid: '',
        mobile: '',
        phone: '00-00000000',
        office_phone: '00-00000000#0000',
        fax: '00-00000000',
        address: '',
        office_address: '',
      },
      insurance:{  
        cathay: [], //國泰
        others: [], //其他
        group: [], //國泰團險
        accident: [], //國泰意外
        health: [], //國泰健康
        harm: [], //國泰傷害
        cathayNewInsure: [], //國泰新種
        otherNewInsure: [], //其他新種
        travel: [], //國泰綜旅
        cathayCar: [], //國泰車險
        cathayFire: [], //國泰火險
        otherCar: [], //其他車險
        otherFire: [] //其他火險        
      }
    }
  },
  methods: {
    ...mapActions(['updateCustID']),
    initial(){   //取得基本資料  
        let custId = ''
        if (!this.$store.state.custInfo.ID || !this.$store.state.custInfo.serNo) {  // 如果 Vuex 沒有 ID 資訊
          if (localStorage.CustID) {
            custId = localStorage.CustID
          } else {
            custId = localStorage.SerNo
          }
        } else {  // 使用 Vuex ID 資訊
          if(this.$store.state.custInfo.ID !== '') {
            custId = this.$store.state.custInfo.ID
          } else {
            custId = this.$store.state.custInfo.serNo
          }
        }
        this.loadingCust = true
        getCustInfo(this.$store.state.userInfo.id, this.$store.state.userInfo.id , custId).then(result => { // 取得客戶列表
          if(result.header && result.header.status == '200'){
               this.customer = {   
                  id: result.body.customer.id, //id
                  name: result.body.customer.name, //name
                  vip_lvl: result.body.customer.vip_lvl, //lv
                  sex: result.body.customer.sex, //性別
                  lineid: result.body.customer.lineid || '', //lineId
                  birthday: result.body.customer.birthday, //生日
                  mobile: result.body.customer.mobile, //手機
                  corpAdd: [result.body.customer.corp_addr_zip? result.body.customer.corp_addr_zip.trim() :'', result.body.customer.corp_addr1? result.body.customer.corp_addr1.trim() :'', result.body.customer.corp_addr2? result.body.customer.corp_addr2.trim() :'', result.body.customer.corp_addr3? result.body.customer.corp_addr3.trim() :''], //公司地址
                  homeAdd: [result.body.customer.home_addr_zip? result.body.customer.home_addr_zip.trim() :'', result.body.customer.home_addr1? result.body.customer.home_addr1.trim() :'', result.body.customer.home_addr2? result.body.customer.home_addr2.trim() :'', result.body.customer.home_addr3? result.body.customer.home_addr3.trim() :''], //現居地址
                  tel: (result.body.customer.home_tel_area ? result.body.customer.home_tel_area : '') +'-'+ (result.body.customer.home_tel ? result.body.customer.home_tel : ''), //住家電話
                  corpTel: (result.body.customer.corp_tel_area ? result.body.customer.corp_tel_area : '') + '-' + (result.body.customer.corp_tel ? result.body.customer.corp_tel : '') +'#'+ (result.body.customer.corp_tel_ext ? result.body.customer.corp_tel_ext : '') , //公司電話
                  fax: result.body.customer.fax_area + result.body.customer.fax //傳真
                }
          }else{
            console.error('取得客戶列表 API 錯誤')
          } 
          this.loadingCust = false
          this.registerHanlink()
        })
    },
    dateFormatRemoveHMS(value) {
      if (!value || value === "") return "— —";
      let dt = window.moment(value);
      let m = dt.month() + 1 < 10 ? `0${dt.month() + 1}` : dt.month() + 1;
      let d = dt.date();
      return `${dt.year() - 1911}/${m}/${d}`;
    },
    toInsDetail (insType, insData) {  //  導頁至保單明細
      if(insType == 'cathay'){  // 國泰人壽保單
        queryPaymentMessage(this.$store.state.userInfo.id, insData.policy_no).then(result => {
          if(result.header && (result.header.status == '200' || result.header.status == '0')){
            this.setCathayData(insType, insData, result.body)
          }
        })
      }

      if(insType == 'others') {  // 同業保單  其他人壽保單
        this.setOthersData(insType, insData)
      }

      if(insType == 'group') {  //  國泰人壽團險
        this.setGroupData(insType, insData)
      }

      if(insType == 'accident') {  //  國泰人壽意外險  
        this.setAccidentData(insType, insData)
      }

      if(insType == 'health') {  //  國泰產險-健康險
        this.setHealthData(insType, insData)
      }

      if(insType == 'harm') {  //  國泰產險-傷害險
        this.setHarmData(insType, insData)
      }

      if(insType == 'cathayNewInsure') {  //  國泰產險-新種險
        this.setCathayNewInsureData(insType, insData)
      }

      if(insType == 'travel') {  //  國泰產險-旅綜險  
        this.setTravelData(insType, insData)
      }

      if(insType == 'cathayCar') {  //  國泰產險-車險  
        this.setCathayCarData(insType, insData)
      }

      if(insType == 'cathayFire') {  //  國泰產險-火險  
        this.setCathayFireData(insType, insData)
      }

      if(insType == 'otherCar') {  //  其他產險-車險   
        this.setOtherCarData(insType, insData)
      }

      if(insType == 'otherFire') {  //  其他產險-火險   
        this.setOtherFireData(insType, insData)
      }

      if(insType == 'otherNewInsure') {  //  其他產險-新種險   
        this.setOtherNewInsureData(insType, insData)
      }
    },
    setOtherNewInsureData (insType, insData) {
      // 轉換有效期間
      let date = insData.DateInsurance.split('-')
      let endYear = Number(date[0]) + Number(insData.Year)
      let startDate = date.join('/')
      let endDate = `${endYear}/${date[1]}/${date[2]}`
      let Detaildata = [  // 宣告 Vuex data  其他產險-新種險  
        {
          header: { 
            title: '其他產險-新種險',   // 標題
            titleColor: 'blue',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.ContractType || ''}</h5>
              <small># ${insData.PolicyNumber || ''} | ${insData.CompanyName.trim() || ''}</small>
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.FullName || '— —'}</b>`},
            {title: '有效期間', content:`${startDate || '— —'} ~ ${endDate || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.Premium) || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setOtherFireData (insType, insData) {
      // 轉換有效期間
      let date = insData.DateInsurance.split('-')
      let endYear = Number(date[0]) + Number(insData.Year)
      let startDate = date.join('/')
      let endDate = `${endYear}/${date[1]}/${date[2]}`
      let Detaildata = [  // 宣告 Vuex data  其他產險-火險  
        {
          header: {
            title: '其他產險-火險',   // 標題
            titleColor: 'blue',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.ContractType || ''}</h5>
              <small># ${insData.PolicyNumber || ''} | ${insData.CompanyName.trim() || ''}</small>
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.FullName || '— —'}</b>`},
            {title: '有效期間', content:`${startDate || '— —'} ~ ${endDate || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.Premium) || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setOtherCarData (insType, insData) {
      // 轉換有效期間
      let date = insData.DateInsurance.split('-')
      let endYear = Number(date[0]) + Number(insData.Year)
      let startDate = date.join('/')
      let endDate = `${endYear}/${date[1]}/${date[2]}`
      let Detaildata = [  // 宣告 Vuex data  其他產險-車險  
        {
          header: { 
            title: '其他產險-車險',   // 標題
            titleColor: 'blue',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.ContractType || ''}</h5>
              <small># ${insData.PolicyNumber || ''} | ${insData.CompanyName.trim() || ''}</small>
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.FullName || '— —'}</b>`},
            {title: '有效期間', content:`${startDate || '— —'} ~ ${endDate || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.Premium) || '— —'}`},
            {title: '車牌號碼', content:`${insData.LicensePlate || '— —'}`},
            {title: '引擎號碼', content:`${insData.EngineNumber || '— —'}`},
            {title: '車種', content:`${insData.CarType || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setCathayFireData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰產險-火險  
        {
          header: { 
            title: '國泰產險-火險',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.cepln_nm || ''}</h5>
              <small># ${insData.ceplcno || ''}</small>  
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.ceisdnm || '— —'}</b>`},
            {title: '有效期間', content:`${this.$options.filters.dateFormat(insData.ceplcdt) || '— —'} ~ ${this.$options.filters.dateFormat(insData.celpsdt) || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.premium1) || '— —'}`},
            {title: '標地地址', content:`${insData.address || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setCathayCarData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰產險-車險  
        {
          header: {
            title: '國泰產險-車險',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.cepln_nm || ''}</h5>
              <small># ${insData.ceplcno || ''}</small>  
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.ceisdnm || '— —'}</b>`},
            {title: '有效期間', content:`${this.$options.filters.dateFormat(insData.ceplcdt) || '— —'} ~ ${this.$options.filters.dateFormat(insData.celpsdt) || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.premium) || '— —'}`},
            {title: '車牌號碼', content:`${insData.lic_no || '— —'}`},
            {title: '引擎號碼', content:`${insData.updater || '— —'}`},
            {title: '車種', content:`${insData.veh_name || '— —'}`},
            {title: '發照日', content:`${this.$options.filters.ymFormat(insData.lic_date) || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setTravelData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰產險-旅綜險  
        {
          header: {
            title: '國泰產險-旅綜險',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.CEPLN_NM || ''}</h5>
              <small># ${insData.CEPLCNO || ''}</small>  
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.CEISDNM || '— —'}</b>`},
            {title: '出單日期', content:`${this.$options.filters.dateFormat(insData.CEPOLDT) || '— —'}`},
            {title: '有效期間', content:`${this.$options.filters.dateFormat(insData.CEPLCDT) || '— —'} ~ ${this.$options.filters.dateFormat(insData.CELPSDT) || '— —'}`},
            {title: '死殘總保額', content:`${insData.DIE_AMT || '— —'}`}, 
            {title: '保費', content:`${insData.curr || ''} ${this.$options.filters.numberFormat(insData.PREMIUM1) || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setCathayNewInsureData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰產險-新種險  
        {
          header: {
            title: '國泰產險-新種險',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.CEPLN_NM || ''}</h5>
              <small># ${insData.CEPLCNO || ''}</small>  
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.CEISDNM || '— —'}</b>`},
            {title: '要保人', content:`<b>${insData.CEAPCNM || '— —'}</b>`}, //error
            {title: '出單日期', content:`${this.$options.filters.dateFormat(insData.CEPOLDT) || '— —'}`},
            {title: '有效期間', content:`${this.$options.filters.dateFormat(insData.CEPLCDT) || '— —'} ~ ${this.$options.filters.dateFormat(insData.CELPSDT) || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.PREMIUM1) || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setHarmData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰產險-傷害險  
        {
          header: {
            title: '國泰產險-傷害險',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.CEPLN_NM || ''}</h5>
              <small># ${insData.CEPLCNO || ''}</small>  
            `
          },
          contentList: [
            {title: '被保人', content:`<b>${insData.CEISDNM || '— —'}</b>`},
            {title: '要保人', content:`<b>${insData.CEAPCNM || '— —'}</b>`}, 
            {title: '出單日期', content:`${this.$options.filters.dateFormat(insData.CEPOLDT) || '— —'}`},
            {title: '有效期間', content:`${this.$options.filters.dateFormat(insData.CEPLCDT) || '— —'} ~ ${this.$options.filters.dateFormat(insData.CELPSDT) || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.PREMIUM1) || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setHealthData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰產險-健康險  
        {
          header: {
            title: '國泰產險-健康險',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.CEPLN_NM || ''}</h5>
              <small># ${insData.CEPLCNO || ''}</small>  
            `
          },
          contentList: [
            {title: '要保人', content:`<b>${insData.CEAPCNM || '— —'}</b>`},
            {title: '被保人', content:`<b>${insData.CEISDNM || '— —'}</b>`},   // 待跟國壽確認
            {title: '出單日期', content:`${this.$options.filters.dateFormat(insData.CEPOLDT) || '— —'}`},
            {title: '有效期間', content:`${this.$options.filters.dateFormat(insData.CEPLCDT) || '— —'} ~ ${this.$options.filters.dateFormat(insData.CELPSDT) || '— —'}`},
            {title: '保費', content:`${this.$options.filters.numberFormat(insData.PREMIUM2) || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setAccidentData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰人壽意外險   
        {
          header: {
            title: '國泰人壽意外險 ',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">國泰人壽旅平險</h5>
              <small># ${insData.POLICY_NO || ''}</small>  
            `
          },
          contentList: [
            // {title: '被保人', content:`<b>${insData.INSD_NAME || '— —'}</b>`}, // 國壽要求被保人拿掉
            {title: '要保人', content:`<b>${insData.APC_NAME || '— —'}</b>`},
            {title: '有效期間', content:`${this.$options.filters.dateFormat(insData.ISSUE_DATE)} ~ ${this.$options.filters.dateFormat(insData.END_DATE)}`},
            {title: '保費', content:`${insData.Detail.TOT_PREM || '— —'}`},
            {title: '投保人數', content:`${insData.ISSUE_NUM || '— —'}`},
            {title: '目的地', content:`${insData.RGN_CODE_NM || '— —'}`},
            {title: '死殘總保額', content:`${insData.TOT_HD_AMT || '— —'}`},
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setGroupData (insType, insData) {
      let Detaildata = [  // 宣告 Vuex data  國泰人壽團險 
        {
          header: {
            title: '國泰人壽團險 ',   // 標題
            titleColor: 'green',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.prod_name || ''}</h5>
              <small># ${insData.policy_no || ''}</small>  
            `
          },
          contentList: [
            {title: '要保人', content:`<b>${insData.apc_name || '— —'}</b>`},
            {title: '被保人', content:`<b>${insData.insd_name || '— —'}</b>`},
            {title: '有效期間', content:`${insData.issue_date || '— —'} ~ ${insData.end_date || '— —'}`},
            {title: '計畫別', content:`${insData.CLASS || '— —'}`}, 
          ]
        },
      ]
      this.$store.dispatch('setInsDetailData', Detaildata)  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setOthersData (insType, insData) {  // 同業保單  其他人壽保單
      let Detaildata = [  // 宣告 Vuex data   主約
        {
          header: {
            title: '主約',   // 標題
            titleColor: 'blue',  // 設定約名顏色 
            // 保單名稱 & 保單號碼
            content: `
              <h5 class="mt-0">${insData.product || ''}</h5>
              <small># ${insData.policynumber || ''} | ${insData.company.trim() || ''}</small>  
            `
          },
          contentList: [
            {title: '要保人', content:`<b>${insData.applicant || '— —'}</b>`},
            {title: '被保人', content:`<b>${insData.fullname || '— —'}</b>`},
            {title: '年期', content:`${insData.yearperiodtobuy || '— —'}`},
            {title: '繳別', content:`${insData.paymentway || '— —'}`},
            {title: '投保始期', content:`${insData.insurancedate || '— —'}`},
            {title: '保額/ 計畫別', content:`${this.$options.filters.numberUnitFormat(insData.insuranceamount) || '— —'}`},
            {title: '主約保費', content:`${insData.premium || '— —'}`},
            // {title: '保單總繳', content:`${insData.CURR || '— —'} ${insData.cul_prem || '— —'}`},   // 待跟國壽確認
            {title: '年金受益人', content:`${insData.annuity || '— —'}`},
            {title: '滿期受益人', content:`${insData.maturitybenefit || '— —'}`},
            {title: '身故受益人', content:`${insData.deathbenefit || '— —'}`},
            {title: '祝壽金受益人', content:`${insData.birthdaygoodwishbenefit || '— —'}`},
          ]
        },
      ]
      let subData = insData.child.map((insItem, index) => {  // 宣告 Vuex data  附約
        return {
          header: {
            title: `附約(${this.indexFormat(index + 1)})`, 
            titleColor: 'blue',  // 設定約名顏色 
            content: `
              <h5 class="mt-0">${insItem.product || ''}</h5>
            `
          },
          contentList: [
            {title: '要保人', content:`<b>${insItem.applicant || '— —'}</b>`},
            {title: '被保人', content:`<b>${insItem.fullname || '— —'}</b>`},
            {title: '年期', content:`${insItem.yearperiodtobuy || '— —'}`},
            {title: '投保始期', content:`${insItem.insurancedate || '— —'}`},
            {title: '保額/ 計畫別', content:`${this.$options.filters.numberUnitFormat(insItem.insuranceamount) || '— —'}`},
            {title: '附約保費', content:`${insItem.premium || '— —'}`},
            {title: '年金受益人', content:`${insItem.annuity || '— —'}`},
            {title: '滿期受益人', content:`${insItem.maturitybenefit || '— —'}`},
            {title: '身故受益人', content:`${insItem.deathbenefit || '— —'}`},
            {title: '祝壽金受益人', content:`${insItem.birthdaygoodwishbenefit || '— —'}`},
          ]
        }
      })
      this.$store.dispatch('setInsDetailData', [...Detaildata,...subData])  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    setCathayData (insType, insData, payInfo) {   // 設定國泰人壽保單明細
      let Detaildata = [  // 宣告 Vuex data  主約
        {
          header: {
            title: '主約', 
            titleColor: 'green',  // 設定約名顏色 
            content: `
              <h5 class="mt-0">${insData.prod_nm || ''}(${insData.prod_id || ''})</h5>
              <small># ${insData.policy_no || ''}</small>
              <span class="label green">${insData.fet_name || ''}</span>  
            `
          },
          contentList: [ 
            {title: '要保人', content:`<b>${insData.apc_name || ''}</b>`},
            {title: '被保人', content:`<b>${insData.insd_name || ''}</b>`},
            {title: '下次應繳', content:`
              <div>${payInfo.PaymentDetail.CURR || ''} ${payInfo.PaymentDetail.PREM_RCPT || ''}</div>
              <small class="text-gray">下次繳費日 ${this.$options.filters.dateFormat(payInfo.PaymentDetail.NXT_PAY_DATE) || ''}</small>
            `}, 
            {title: '繳費方式/帳號', content:`${insData.pay_kind || ''}/${insData.bank_name || ''}`},
            {title: '保單總繳', content:`${insData.curr || ''} ${this.$options.filters.numberFormat(insData.cul_prem) || ''}`},
            {title: '年期', content:`${insData.pay_prd || ''}`},
            {title: '繳別', content:`${insData.pay_freq || ''}`},
            {title: '投保始期', content:`${this.dateFormatRemoveHMS(insData.issue_date) || ''}`},
            {title: '保額/ 計畫別', content: insData.face_amt_unit == '計劃別' ? `${insData.face_amt_unit || ''} : ${insData.face_amt || ''}` : `${this.$options.filters.numberFormat(insData.face_amt) || ''} ${insData.face_amt_unit || ''}`},
            {title: '主約保費', content:`${insData.curr || ''} ${this.$options.filters.numberFormat(insData.bre_prem) || ''}`},
          ]
        },
      ]
      let subData = insData.child.map((insItem, index) => {  // 宣告 Vuex data  附約
        return {
          header: {
            title: `附約(${this.indexFormat(index + 1)})`, 
            titleColor: 'green',  // 設定約名顏色 
            content: `
              <h5 class="mt-0">${insItem.prod_nm || ''}(${insItem.prod_id || ''})</h5>
              <span class="label green">${insItem.fet_name || ''}</span>  
            `
          },
          contentList: [
            {title: '要保人', content:`<b>${insItem.apc_name || ''}</b>`},
            {title: '被保人', content:`<b>${insItem.insd_name || ''}</b>`},
            {title: '年期', content:`${insItem.pay_prd || ''}`},
            {title: '投保始期', content:`${this.dateFormatRemoveHMS(insData.issue_date) || ''}`},
            {title: '保額/ 計畫別', content: insItem.face_amt_unit == '計劃別' ? `${insItem.face_amt_unit || ''} : ${insItem.face_amt || ''}` : `${this.$options.filters.numberFormat(insItem.face_amt) || ''} ${insItem.face_amt_unit || ''}`},
            {title: '附約保費', content:`${insItem.curr || ''} ${this.$options.filters.numberFormat(insItem.bre_prem) || ''}`},
          ]
        }
      })
      this.$store.dispatch('setInsDetailData', [...Detaildata,...subData])  // 設定 Vuex
      this.$router.push({path: '/customer/insurance'})  // 導頁至保單明細
    },
    policyData(){  //tab為保單資訊
      this.insLoading.cathay = true
      getCustInsurance(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰保單
        this.insLoading.cathay = false
        if(result.header && result.header.status == '200'){
            let mainIns = result.body.policies.filter(item => {  //過濾主約 並增加 child 屬性
              return item.prod_cat == '1'   
            })
            mainIns.forEach(item => {
              if(!item.bank_name) {
                item.bank_name = '查無資料'
              }
              item.child = []
            })
            let subIns = result.body.policies.filter(item => {  //過濾附約
              return item.prod_cat == '2'  
            })
            mainIns.forEach(mainItem => {
              subIns.forEach(subItem => {
                if(mainItem.policy_no == subItem.policy_no){
                  mainItem.child.push(subItem)
                }
              })
            })
            this.insurance.cathay = mainIns
        }else{
          console.error('取得國泰保單 API 錯誤')
        }
      })   
      this.insLoading.others = true
      getCustOtherInsurance(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得其他保單
        this.insLoading.others = false
        let mainIns = [];
        let secondaryIns = [];
        this.insurance.others = []         
        if(result.header && result.header.status === '200') {
          result.body.insuredcontractlist.forEach((item, index) => {
            item.contractcontentlist.forEach((item2,index) => {
              if(item2.contracttype == '主約'){
                mainIns.push({
                  ...item2,
                  birthday:item.birthday || '',
                  personalid:item.personalid || '',
                  fullname:item.fullname || '',
                  child: [],
                })
              }else{
                secondaryIns.push({
                  ...item2,
                  birthday:item.birthday || '',
                  personalid:item.personalid || '',
                  fullname:item.fullname || '',
                })
              }
            })
          })

          //移除重複的保單
          // 過濾主約 contractid
          let removeSameIdObj = {}
          mainIns.map(ins => removeSameIdObj[ins.contractid] = ins)
          mainIns = Object.values(removeSameIdObj)

          // 過濾主約 contractid 中如果有 policynumber 一樣的 依照 personalid = custID 顯示
          let removeAry = {}
          const vm = this
          mainIns.map(item => {return item.policynumber}).forEach(item => {
            removeAry[item] = []
          })
          mainIns.forEach(item => {
            removeAry[item.policynumber].push(item)
          })
          for (let key in removeAry) {
            if (removeAry[key].length > 1) {
              removeAry[key] = removeAry[key].filter(item => {
                return item.personalid == vm.$store.state.custInfo.ID
              })
            }
          }
          mainIns = []
          removeAry = Object.values(removeAry)
          removeAry.forEach(item => {
            mainIns = [...mainIns,...item]
          })

          // 過濾附約 contractid
          let removeSameIdSubInsObj = {}
          secondaryIns.forEach(ins => removeSameIdSubInsObj[ins.contractid] = ins)
          secondaryIns = Object.values(removeSameIdSubInsObj)

          // 過濾附約 contractid 中如果有 policynumber 一樣的 依照 personalid = custID 顯示
          let removeSubAry = {}
          secondaryIns.map(item => {return item.policynumber}).forEach(item => {
            removeSubAry[item] = []
          })
          secondaryIns.forEach(item => {
            removeSubAry[item.policynumber].push(item)
          })
          for (let key in removeSubAry) {
            if (removeSubAry[key].length > 1) {
              removeSubAry[key] = removeSubAry[key].filter(item => {
                return item.personalid == vm.$store.state.custInfo.ID
              })
            }
          }
          secondaryIns = []
          removeSubAry = Object.values(removeSubAry)
          removeSubAry.forEach(item => {
            secondaryIns = [...secondaryIns,...item]
          })

          mainIns.forEach((main,mIndex) => {
            let chlidAry = []
            secondaryIns.forEach((attr,aIndex) => {
              if(main.policyid === attr.policyid){
                chlidAry.push(attr) 
              }
            })
            mainIns[mIndex].child = chlidAry
          })

          this.insurance.others = mainIns;

        }else{
          console.error('取得其他保單 API 錯誤')
        }
      })   
      this.insLoading.group = true
      getCustInsuranceGroup(this.$store.state.userInfo.id,  this.$store.state.custInfo.ID).then(result => { // 取得國泰團險
        this.insLoading.group = false
        console.log('取得國泰團險',result)
        if(result.header && result.header.status == '200'){
            this.insurance.group = result.body.detail
        }else{
          console.error('取得國泰團險 API 錯誤')
        }
      })   
      this.insLoading.accident = true
      getCustInsuranceAccident(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰意外險
         this.insLoading.accident = false
         console.log('取得國泰意外險',result)
        if(result.header && result.header.status == '200'){
          if(result.body.AccidentPolicy){
            this.insurance.accident = result.body.AccidentPolicy
          }else if(result.body.TravelPolicy){
            this.insurance.accident = result.body.TravelPolicy
          }
        }else{
          console.error('取得國泰意外險 API 錯誤')
        }
      })   
      this.insLoading.health = true
      getCustInsurance_CCIPLN4(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰健康險
        this.insLoading.health = false
        if(result.header && result.header.status == '200'){
            this.insurance.health = result.body
        }else{
          console.error('取得國泰健康險 API 錯誤')
        }
      })   
      this.insLoading.harm = true
      getCustInsurance_CCIPLN2(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰傷害險
        this.insLoading.harm = false
        if(result.header && result.header.status == '200'){
            this.insurance.harm = result.body
        }else{
          console.error('取得國泰傷害險 API 錯誤')
        }
      })   
      this.insLoading.cathayNewInsure = true
      getCustInsurance_CCIPLN1(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰新種險
        this.insLoading.cathayNewInsure = false
        if(result.header && result.header.status == '200'){
            this.insurance.cathayNewInsure = result.body
        }else{
          console.error('取得國泰新種險 API 錯誤')
        }
      })   
      this.insLoading.travel = true
      getCustInsurance_CCIPLN3(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰旅綜險
        this.insLoading.travel = false
        if(result.header && result.header.status == '200'){
            this.insurance.travel = result.body
        }else{
          console.error('取得國泰旅綜險 API 錯誤')
        }
      })   
      this.insLoading.cathayCar = true
      getCustInsurance_CCIPLC1(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰車險
        this.insLoading.cathayCar = false
        if(result.header && result.header.status == '200'){
            this.insurance.cathayCar = result.body
        }else{
          console.error('取得國泰車險 API 錯誤')
        }
      })   
      this.insLoading.cathayFire = true
      getCustInsurance_CCIPLF1(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result => { // 取得國泰火險
        this.insLoading.cathayFire = false
        if(result.header && result.header.status == '200'){
            this.insurance.cathayFire = result.body
        }else{
          console.error('取得國泰火險 API 錯誤')
        }
      })  
      this.insLoading.otherRest = true
      getAllInsurances(this.$store.state.userInfo.id,this.$store.state.custInfo.ID).then(result => { // 取得其他車、火、新種險
        this.insLoading.otherRest = false
        if(result.header && result.header.status == '200'){
            this.insurance.otherCar = result.body.MotorInsuranceList
            this.insurance.otherFire = result.body.FireInsuranceList
            this.insurance.otherNewInsure = result.body.CasualtyInsuranceList
        }else{
          console.error('取得取得其他車、火、新種險 API 錯誤')
        }
      })                                                                                          
    },
    indexFormat(num){ // filter 附約格式
      const ref = [
        {code: '0', text: '零'},
        {code: '1', text: '一'},
        {code: '2', text: '二'},
        {code: '3', text: '三'},
        {code: '4', text: '四'},
        {code: '5', text: '五'},
        {code: '6', text: '六'},
        {code: '7', text: '七'},
        {code: '8', text: '八'},
        {code: '9', text: '九'},
      ]
      let numAry = num.toString().split('')
      numAry = numAry.map(numItem => {
        let transferText = '?'
        ref.forEach(textItem => {
          if (textItem.code == numItem) {
            transferText = textItem.text
          }
        })
        return transferText
      })
      return numAry.join('')
    },
    resetCustId (custID) {  // 更新客戶 ID 並轉到 tab-0
      this.updateCustID(custID)
      localStorage.CustID = custID
      this.initial()
      $(`a[href="#tab-0"]`).click()
    },
  },
  mounted () {
    document.body.onscroll = () => {
      let scroll = document.scrollTop || document.body.scrollTop || document.scrollingElement.scrollTop || 0;
      let go = document.querySelector('#gotop')
      if( scroll > 300) {
        go.classList.add('is-show')
      } else {
        go.classList.remove('is-show')
      }
    }
    this.initial() 
  }
}
</script>

<style lang="scss" scoped>

.load-mag {
  height: 400px;
  line-height: 390px;
}

</style>
